import React, { useState } from 'react'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { theme } from '../../../../theme/theme'
import { TabBar } from '../../../common/TabBar'
import { SocietyInformation } from '../SocietyInformation'
import { JoinInactiveSocietyBoard } from './JoinInactiveSocietyBoard'
import { JoinInactiveSocietyMember } from './JoinInactiveSocietyMember'
import { ISocietiesModel } from '../../../../interfaces/models/societies.interfaces'
import { i18nSocietyType } from '../../../../i18n'

export enum ActiveTabBar {
  MEMBER = 0,
  BOARD = 1,
}

interface InactiveSocietyProps {
  society: ISocietiesModel
}

export const InactiveSociety = ({
  society,
}: InactiveSocietyProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  const [activeTab, setActiveTab] = useState<ActiveTabBar>(ActiveTabBar.MEMBER)

  return (
    <div className="mr-6 flex flex-col md:mr-2">
      <p style={theme.textVariants.h3}>
        {translate('inactiveSociety.title', {
          context: i18nSocietyType(society?.societyTypeDisplayName),
        })}
      </p>
      <p className="max-w-96 my-4" style={theme.textVariants.base}>
        {translate('inactiveSociety.subtitle', {
          context: i18nSocietyType(society?.societyTypeDisplayName),
        })}
      </p>
      <SocietyInformation alignTextStart society={society} />
      <div className="mt-6 border-t" />
      <TabBar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        className="mt-2 md:mt-4"
        tabs={[
          {
            title: translate('inactiveSociety.tabs.member'),
          },
          {
            title: translate('inactiveSociety.tabs.board'),
          },
        ]}
      />
      <div className="w-full py-2 md:py-4">
        {ActiveTabBar.MEMBER === activeTab ? (
          <>{society && <JoinInactiveSocietyMember society={society} />}</>
        ) : (
          <>{society && <JoinInactiveSocietyBoard society={society} />}</>
        )}
      </div>
    </div>
  )
}
